import { endpoint } from '@library/endpoint'

import { fetch } from 'utils/fetch'

export function legacyVerifyAge() {
  // TODO: confirm with Tomatoes if this endpoint is in use
  const data = fetch(
    null,
    `${endpoint('webclient')}/user/public-age-verified`,
    {},
    'POST',
    'default',
    {},
    null,
    true,
  )

  return data
}
